<template>
  <section>
    <images-list v-if="images" :images="images" :title="images.Product.ProductName"></images-list>
  </section>
</template>

<script>
import { getResource } from "../../vuex/helpers";
import ImagesList from "./ImagesList";
import { getImages } from "./ImagesActions";

export default {
  components: {
    ImagesList
  },
  vuex: {
    getters: {
      images: state => state.images
    },
    actions: { getImages, getResource }
  },
  route: {
    data ({ to: { params: { id } } }) {
      this.getImages(id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// Images.vue?b4524084